import Button from "@/components/bricks/button/Button";
import DownloadIcon from "@/components/icons/DownloadIcon";
import Spinner from "@/components/spinner/Spinner";

interface EvidencePdfViewerProps {
  fileName: string;
  isDownloading?: boolean;
  isLoading: boolean;
  onDownload?: () => void;
  pdfUrl?: string;
}

export const EvidencePdfViewer = ({
  fileName,
  isDownloading = false,
  isLoading,
  onDownload,
  pdfUrl,
}: EvidencePdfViewerProps) => (
  <div className="c-card">
    <div className="d-flex justify-content-between align-items-center mb-3">
      <h3 className="mb-0">
        {fileName.length > 30 ? fileName.substring(0, 30) + "..." : fileName}
      </h3>
      {onDownload ? (
        <Button
          color="-action"
          type="button"
          disabled={isDownloading}
          onClick={onDownload}
        >
          {isDownloading ? <Spinner size={14} /> : <DownloadIcon height={16} />}
          Hent PDF
        </Button>
      ) : (
        <span className="text-muted">{fileName}</span>
      )}
    </div>
    <div
      className="border rounded bg-white d-flex align-items-center justify-content-center"
      style={{ minHeight: 820 }}
    >
      {isLoading && <Spinner label="Henter PDF ..." />}
      {!isLoading && pdfUrl && (
        <object
          aria-label={`PDF-visning for ${fileName}`}
          className="w-100 h-100  border rounded"
          data={pdfUrl}
          style={{ minHeight: 820 }}
          type="application/pdf"
        >
          <a href={pdfUrl} rel="noreferrer" target="_blank">
            Åbn PDF
          </a>
        </object>
      )}
      {!isLoading && !pdfUrl && (
        <div className="text-muted">PDF-forhåndsvisning kunne ikke vises.</div>
      )}
    </div>
  </div>
);
